import {
  container,
  cardTitle,
  whiteColor,
  grayColor,
} from "assets/jss/material-dashboard-pro-react.js";

const loginPageStyle = (theme) => ({
  container: {
    ...container,
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px",
    },
  },
  cardTitle: {
    ...cardTitle,
    color: whiteColor,
  },
  textCenter: {
    textAlign: "center",
  },
  justifyContentCenter: {
    justifyContent: "center !important",
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: whiteColor,
    },
    marginLeft: "5px",
    marginRight: "5px",
  },
  inputAdornment: {
    marginRight: "18px",
  },
  inputAdornmentIcon: {
    color: grayColor[6],
  },
  optionInput: {
    marginRight:"10px"
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)",
  },
  cardHeader: {
    marginBottom: "20px",
  },
  socialLine: {
    padding: "0.9375rem 0",
  },
  socialTitle: {
    color: "#13816F",
    fontWeight: "bold"
  },
  containerLogin: {
    overflow: "hidden"
  },
  badge: {
    display: "inline-block",
    padding: "4px 10px",
    fontSize: "12px",
    fontWeight: "bold",
    lineHeight: "1",
    textTransform: "uppercase",
    borderRadius: "12px",
    color: "#fff",
    backgroundColor: theme.palette.primary.main, // Color principal
    whiteSpace: "nowrap",
  },
  success: {
    backgroundColor: theme.palette.success.main,
  },
  danger: {
    backgroundColor: theme.palette.error.main,
  },
  warning: {
    backgroundColor: theme.palette.warning.main,
  },
  info: {
    backgroundColor: theme.palette.info.main,
  },
  gray: {
    backgroundColor: theme.palette.grey[500],
  },
  displayNone: {
    display: "none"
  }
});

export default loginPageStyle;
